export default "__VITE_ASSET__DigAd9YD__"